import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import App, { APP_PLATFORM_TYPE_TELEGRAM, APP_PLATFORM_TYPE_VK } from './App';
import { RouterProvider } from '@vkontakte/vk-mini-apps-router';
import { parseQueryString } from './helpers/helpers';
import './styles.css';
import * as Sentry from '@sentry/browser';
import { AppStoreProvider } from './AppStore';
import { router } from './route';

if (
  process.env.REACT_APP_PLATFORM_TYPE !== APP_PLATFORM_TYPE_TELEGRAM &&
  process.env.REACT_APP_PLATFORM_TYPE !== APP_PLATFORM_TYPE_VK
) {
  throw new Error('Платформа не указана');
} else if (process.env.REACT_APP_PLATFORM_TYPE === APP_PLATFORM_TYPE_TELEGRAM) {
  if (process.env.NODE_ENV === 'development') {
    // import('./theme_dark.css');
  }

  import('./colors.css');
}

const appOpenParams = parseQueryString(window.location.search, window.location.hash);

if (process.env.REACT_APP_SENTRY_URL) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.2,
    tracePropagationTargets: ['localhost'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });
}

const rootElement = document.getElementById('root');
const root = ReactDOMClient.createRoot(rootElement);

root.render(<RouterProvider router={router} notFoundRedirectPath="/">
  <AppStoreProvider>
    <App
      appOpenParams={appOpenParams}
      platform={process.env.REACT_APP_PLATFORM_TYPE || APP_PLATFORM_TYPE_VK}
    />
  </AppStoreProvider>
</RouterProvider>);

if (process.env.NODE_ENV === 'development') {
  import('./eruda').then(({ default: eruda }) => {}); //runtime download
}
